import React, { useState } from "react";
import { Briefcase, ChevronDown, Sparkles, Database, Workflow, Calendar } from "lucide-react";

export default function CaseStudyShowcaseSection({ caseStudies, onExpand }) {
  const [expandedId, setExpandedId] = useState(null);
  if (!caseStudies || caseStudies.length === 0) {
    return <p className="text-sm text-slate-400 text-center py-6" data-testid="portfolio-no-case-studies">No completed enterprise case studies yet.</p>;
  }
  const toggle = (cs) => {
    const opening = expandedId !== cs.id;
    setExpandedId(opening ? cs.id : null);
    if (opening && onExpand) onExpand(cs.id);
  };
  return (
    <div className="space-y-3" data-testid="portfolio-case-study-showcase">
      {caseStudies.map((cs) => {
        const expanded = expandedId === cs.id;
        return (
          <div key={cs.id} className="bg-white/[0.02] border border-white/5 rounded-xl overflow-hidden" data-testid={`showcase-case-study-${cs.id}`}>
            <button onClick={() => toggle(cs)} className="w-full flex items-center justify-between gap-3 p-4 text-left" data-testid={`showcase-case-study-toggle-${cs.id}`}>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-purple-500/10 flex items-center justify-center shrink-0"><Briefcase className="w-4 h-4 text-purple-300" /></div>
                <div>
                  <p className="text-sm font-semibold text-white">{cs.title}</p>
                  <p className="text-xs text-slate-400">{cs.industry} · {cs.portfolio_headline}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-sm font-bold text-indigo-400">{cs.overall_score}%</span>
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${expanded ? "rotate-180" : ""}`} />
              </div>
            </button>
            {expanded && (
              <div className="px-4 pb-4 space-y-3 border-t border-white/5 pt-3" data-testid={`showcase-case-study-details-${cs.id}`}>
                <div>
                  <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 mb-1">Business Problem</p>
                  <p className="text-xs text-slate-400 leading-relaxed">{cs.business_problem}</p>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center gap-2 text-xs text-slate-400"><Workflow className="w-3.5 h-3.5 text-emerald-300" /> Pipeline Score: <span className="text-white font-semibold">{cs.simulator_score}%</span></div>
                  <div className="flex items-center gap-2 text-xs text-slate-400"><Database className="w-3.5 h-3.5 text-amber-300" /> SQL Score: <span className="text-white font-semibold">{cs.sql_score}%</span></div>
                </div>
                {cs.ai_summary && (
                  <div className="bg-indigo-400/5 border border-indigo-400/20 rounded-lg p-3 flex items-start gap-2">
                    <Sparkles className="w-3.5 h-3.5 text-indigo-400 mt-0.5 shrink-0" />
                    <p className="text-xs text-slate-300 leading-relaxed">{cs.ai_summary}</p>
                  </div>
                )}
                <div className="flex items-center gap-1.5 text-[11px] text-slate-400"><Calendar className="w-3 h-3" /> Completed {new Date(cs.completed_at).toLocaleDateString()}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
